/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import Popup from './Popup/index'
import React from 'react'
import TysiaIconPeopleFilled from 'DesignSystem/Svgs/TysiaIconPeopleFilled/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/DataVaxiomRelationshipsItem/Edit/NonPatient/Postal/Addresses/Content/Address/Related/Content"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtColorsGreen700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.700'
        })
  return (<React.Fragment
>
<Popup
  viewPath={`${viewPath}/Popup`}
/>
<button
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, 'Popup/Content'))}
 {...isHoveredBind}
 className={`views-block ${styles.Vertical}`}
>
<TysiaIconPeopleFilled
  viewPath={`${viewPath}/TysiaIconPeopleFilled`}
 fill={dtColorsGreen700}
/>
</button>
{children}
</React.Fragment>)
}